module.exports = __webpack_public_path__ + "assets/img/sk.3d85d677.png";